"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationResolver = void 0;
var common_core_1 = require("@moralisweb3/common-core");
var OperationRequestBuilder_1 = require("./OperationRequestBuilder");
var OperationResolver = /** @class */ (function () {
    function OperationResolver(operation, baseUrl, core) {
        var _this = this;
        this.operation = operation;
        this.baseUrl = baseUrl;
        this.core = core;
        this.requestValidator = new common_core_1.OperationRequestValidator(this.operation);
        this.requestBuilder = new OperationRequestBuilder_1.OperationRequestBuilder(this.operation, this.core);
        this.requestController = common_core_1.RequestController.create(this.core);
        this.fetch = function (request) { return __awaiter(_this, void 0, void 0, function () {
            var _a, url, urlSearchParams, body, jsonResponse;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.requestValidator.validate(request);
                        _a = this.requestBuilder.prepareUrl(this.baseUrl, request), url = _a.url, urlSearchParams = _a.urlSearchParams;
                        body = this.requestBuilder.prepareBody(request);
                        return [4 /*yield*/, this.requestController.request({
                                method: this.operation.method,
                                url: url,
                                params: urlSearchParams,
                                headers: this.requestBuilder.prepareHeaders(),
                                data: body,
                            })];
                    case 1:
                        jsonResponse = _b.sent();
                        return [2 /*return*/, new common_core_1.ResponseAdapter(jsonResponse, function () {
                                return _this.operation.deserializeResponse(jsonResponse, request, _this.core);
                            })];
                }
            });
        }); };
        if (operation.isNullable) {
            throw new Error("Operation ".concat(operation.name, " has invalid value for isNullable property"));
        }
    }
    return OperationResolver;
}());
exports.OperationResolver = OperationResolver;
//# sourceMappingURL=OperationResolver.js.map